import styled from "styled-components";
import { ButtonShareInterface } from "./interfaces";

import colors from "../../assets/css/colors";

export const LinkContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
`

export const ButtonDownload = styled.button`
    width: 285px;
    height: 43px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
    padding-right: 7px;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
    border-radius: 7px;
    background-color: #FFF;
    margin-bottom: 16px;
    
    &:focus {
        outline-color: ${colors.primary};
    }
`

export const ButtonLink = styled.button`
    width: 285px;
    height: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    padding-right: 7px;
    border: 1px dashed ${colors.grayDark};
    border-radius: 7px;
    background-color: #FFF;
    margin-bottom: 26px;
`

export const ButtonLinkText = styled.p`
    width: 70%;
    margin-bottom: 0px;
    font: normal normal normal 12px/16px Circular Std Book;
    color: ${colors.tertiary};
`
export const ButtonLinkCopy = styled.div`
    width: 30%;
    font: normal normal normal 12px/16px Circular Std Book;
    color: ${colors.grayDark};
`

export const ButtonShare = styled.button`
    width: 285px;
    height: 43px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: ${(p: ButtonShareInterface) =>  `1px solid ${p.color}`};
    color: ${(p: ButtonShareInterface) =>  `${p.color}`};
    border-radius: 7px;
    background-color: ${colors.white};
    margin-bottom: 14px;
`

export const ButtonShareText = styled.p`
    font: normal normal 600 14px/18px Muli;
    margin-left: 18px;
    margin-bottom: 0px;
`

export const TextContainer = styled.div`
    width: 100%;
    /* height: 76px; */
    display: flex;
    justify-content: center;
`;

export const TextMessage = styled.p`
    width: 250px;
    text-align: center;
    color: ${colors.primary};
    font: normal normal normal 32px/44px Circular Std Book;
    margin-bottom: 20px;
`;

export const QrCodeContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ModalFooter = styled.div`
    height: 100px;
    align-items: flex-start;
    padding: 0;
`;
